// extracted by mini-css-extract-plugin
export default {"NoWalletConnected":"NoWalletConnected_NoWalletConnected__BKE9O","textSection":"NoWalletConnected_textSection__En2gx"};